@if (routingData.isSkeleton) {
  <div #canvasContainer class="h-[60vh] w-[60vw] flex flex-col">
    <canvas #paintCanvas oncontextmenu="return false;"></canvas>
    @for (legendEntry of routingData.skeletonAnnotation?.legendElements; track legendEntry) {
      @if (legendEntry.y) {
        <div class="flex w-[50vw] pt-10">
          <div class="flex w-[3vw] justify-center items-center">
            <div class="w-[2vw] h-[1vh]" [style]="{background:legendEntry.x}"></div>
          </div>
          <div class="w-[47vw]">
            <input [id]="getInputId(legendEntry)" type="text" variant="filled" fluid="true" [disabled]="true" pInputText
                   pSize="large" [value]="legendEntry.y"
            />
          </div>
        </div>
      }
    }
  </div>
} @else {
  <div #canvasContainer class="h-[60vh] w-[60vw] flex flex-col ">
    @if (routingData.document.documentType == 'Image') {
      <canvas #paintCanvas oncontextmenu="return false;"></canvas>
      @for (legendEntry of routingData.document.annotation?.legendElements; track legendEntry) {
        @if (legendEntry.y) {
          <div class="flex w-[50vw] pt-10">
            <div class="flex w-[3vw] justify-center items-center">
              <div class="w-[2vw] h-[1vh]" [style]="{background:legendEntry.x}"></div>
            </div>
            <div class="w-[47vw]">
              <input [id]="getInputId(legendEntry)" type="text" variant="filled" fluid="true" [disabled]="true"
                     pInputText pSize="large" [value]="legendEntry.y"
              />
            </div>
          </div>
        }
      }
    }
    @if (routingData.document.documentType == 'Document') {
      @if (routingData.document.documentType == 'Document') {
        <div class="h-[60vh]">
          <object
            class="w-[100%] h-[100%]"
            [data]="pdfUrl"
            type="application/pdf"
          >
            <p>Ihr Browser unterstützt keine eingebetteten PDFs.
              <a [href]="pdfUrl" target="_blank">PDF hier herunterladen</a>.
            </p>
          </object>
        </div>
      }
    }
  </div>
}
